export const modalTypes = {
  ACCESS_POLICY_MODAL: 'accessPolicyModal',
  BEFORE_YOU_GO_CONFIRMATION_MODAL: 'beforeYouGoConfirmationModal',
  GUEST_POLICY_MODAL: 'guestPolicyModal',
  SELECT_CARD_MODAL: 'selectCardModal',
  TERMS_MODAL: 'termsModal',
};
